// Service pour appeler le proxy Runware côté Worker

const WORKER_BASE = 'https://onyros-api.atelier-davai.workers.dev';

export interface RunwareGenerateParams {
  prompt: string;
  model?: string;
  width?: number;
  height?: number;
  steps?: number;
  // champs additionnels si besoin
  [key: string]: any;
}

export interface RunwareGenerateResponse {
  success: boolean;
  status: number;
  data: any;
  dataUrl?: string | null;
}

export async function generateImage(params: RunwareGenerateParams): Promise<RunwareGenerateResponse> {
  const res = await fetch(`${WORKER_BASE}/api/runware/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  });
  let json: any = null;
  try { json = await res.json(); } catch { json = { raw: await res.text().catch(() => '') }; }
  // Toujours renvoyer le payload pour que l'appelant puisse afficher le message d'erreur Runware
  return {
    success: !!json?.success && res.ok,
    status: json?.status ?? res.status,
    data: json?.data ?? json,
    dataUrl: json?.dataUrl ?? null,
  } as RunwareGenerateResponse;
}
